exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".navbar-inverse .navbar-nav > li.whats-new > a.unread {\n  color: var(--color-alert);\n  font-weight: 400;\n}\n@media (min-width: 768px) and (max-width: 992px) {\n  .navbar-inverse .navbar-nav > li.whats-new > a.unread {\n    line-height: 20px;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/whatsNew/whatsNew.less
// module id = 3239
// module chunks = 0